module.exports = ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%;\n  max-width: 1650px;\n  margin: auto;\n  padding: 40px 20px 60px; }\n  @media screen and (min-width: 1200px) {\n    .container {\n      padding-left: 30px;\n      padding-right: 30px; } }\n  .panel {\n  width: 100%;\n  max-width: 970px;\n  margin: auto; }\n  .panel-body app-tree-list .tree-list li a:hover {\n  background-color: black !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/list-modal/list-modal.component.scss
// module id = ./src/app/components/list-modal/list-modal.component.scss
// module chunks = main